import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Header } from './components/header/header';
import { Footer } from './components/footer/footer';
import { SeoService } from './services/seo.service';
import { DOCUMENT } from '@angular/common';
import { Inject } from '@angular/core';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Header, Footer],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  standalone: true
})
export class App implements OnInit {
  protected title = environment.title;

  constructor(
    private seoService: SeoService,
    @Inject(DOCUMENT) private document: Document
  ) {}

  ngOnInit() {
    this.seoService.init();

    if ((environment as any).favicon) {
      const link = this.document.getElementById('app-favicon') as HTMLLinkElement;
      if (link) {
        link.href = (environment as any).favicon;
      }
    }
  }
}
